<template>
	<div style="max-width: 960px; padding:12px;">
		<v-form>
			<v-card class="mb-4">
				<v-toolbar card prominent>
					<v-text-field v-model="form.name" :error-messages="nameErrors" placeholder="Template Name" required autofocus background-color="#fff"></v-text-field>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-card-text class="text-xs-left">
					<performance-review-item-builder :edit="true" :review-items="template.reviewItems" />
				</v-card-text>
			</v-card>

			<v-footer color app height="55">
				<v-spacer></v-spacer>
				<footer-back-btn @click="cancel" />

				<v-btn v-if="isAdmin" class="action-btn" :loading="isSaving" :disabled="isSaving" @click="submit">
					Save
					<v-icon right>send</v-icon>
					<span slot="loader">Saving...</span>
				</v-btn>
			</v-footer>
		</v-form>
	</div>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import PerformanceReviewItemBuilder from '@/components/performanceReview/PerformanceReviewItemBuilder';

	export default {
		props: {
			isAdmin: {
				type: Boolean,
				required: true
			},
			template: {
				type: Object,
				default: () => ({
					id: null,
					name: '',
					reviewItems: []
				})
			},
			isSaving: {
				required: false,
				default: false,
				type: Boolean
			},
			title: {
				required: true,
				type: String
			}
		},
		components: {
			PerformanceReviewItemBuilder
		},
		data() {
			return {
				form: {
					id: this.template.id,
					name: this.template.name,
					reviewItems: this.template.reviewItems
				}
			};
		},
		computed: {
			nameErrors() {
				const errors = [];
				if (!this.$v.form.name.$dirty) return errors;
				!this.$v.form.name.required && errors.push('Template Name is required.');
				return errors;
			}
		},
		methods: {
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					if (this.template.id === null || confirm('Are you sure you wish to update this Template?')) {
						let postObj = {
							id: this.form.id != undefined ? this.form.id : this.newGuid(),
							name: this.form.name,
							reviewItems: this.form.reviewItems
						};

						this.$emit('save', postObj);
					}
				}
			},
			cancel() {
				window.history.back();
			}
		},
		mixins: [validationMixin],
		validations: {
			form: {
				name: { required }
			}
		}
	};
</script>

<style></style>
